import {
  DashboardOutlined,
  PhoneForwardedOutlined,
  PermPhoneMsgOutlined,
  SmsOutlined,
  CellTowerOutlined,
  CreditScoreOutlined,
  ShopOutlined,
  PaymentsOutlined,
  AccountBalanceWalletOutlined,
  InsertChartOutlined,
  BadgeOutlined,
  AppSettingsAltOutlined,
  AccountBalanceOutlined,
  GroupsOutlined,
  AssignmentTurnedInOutlined,
  SmartphoneOutlined,
  PhoneInTalk
} from '@mui/icons-material';

import { PAGE_TITLE, SERVICE_CATEGORY_TITLE } from '../../../consts';
import { PORTAL_PATH, EXTERNAL_PATH } from '../../../../../routes/paths';

import { MenuSection } from './interfaces';
import { CheckIfUserHasPortalPrivilege } from '../../../../../common/client-status/interfaces';

const withoutSection: MenuSection = {
  menuItems: [
    {
      title: PAGE_TITLE.DASHBOARD,
      icon: DashboardOutlined,
      href: PORTAL_PATH.DASHBOARD,
      portalPrivilegeVerification: (verify: CheckIfUserHasPortalPrivilege) => verify('OPERATION_HISTORY')
    },
    {
      title: PAGE_TITLE.WALLET,
      icon: AccountBalanceWalletOutlined,
      href: PORTAL_PATH.WALLET_CREDITS_HISTORY,
      portalPrivilegeVerification: (verify: CheckIfUserHasPortalPrivilege) => verify('WALLET_CREDIT')
    },
    {
      title: PAGE_TITLE.USER_MANAGEMENT,
      icon: GroupsOutlined,
      href: PORTAL_PATH.SUB_ACCOUNTS_MANAGEMENT,
      portalPrivilegeVerification: (verify: CheckIfUserHasPortalPrivilege) => verify('USER_MANAGEMENT')
    },
    {
      title: PAGE_TITLE.PRODUCTS_AND_SERVICES,
      icon: null,
      href: PORTAL_PATH.PRODUCTS_AND_SERVICES,
      portalPrivilegeVerification: (verify: CheckIfUserHasPortalPrivilege) => verify('EXPLORE_PRODUCTS'),
      excludeFromNavigation: true
    }
  ]
};

const access: MenuSection = {
  title: SERVICE_CATEGORY_TITLE.ACCESS,
  menuItems: [
    {
      title: PAGE_TITLE.USSD,
      icon: PermPhoneMsgOutlined,
      href: PORTAL_PATH.USSD,
      portalPrivilegeVerification: (verify: CheckIfUserHasPortalPrivilege) =>
        verify('USSD_BILLING_REPORTS') || verify('USSD_SETTINGS')
    },
    {
      title: PAGE_TITLE.SMS,
      icon: SmsOutlined,
      href: PORTAL_PATH.SMS_BILLING,
      portalPrivilegeVerification: (verify: CheckIfUserHasPortalPrivilege) => verify('SMS_BILLING_REPORTS')
    },
    {
      title: PAGE_TITLE.WAP,
      icon: SmartphoneOutlined,
      href: PORTAL_PATH.WAP,
      portalPrivilegeVerification: (verify: CheckIfUserHasPortalPrivilege) =>
        verify('WAP_BILLING_REPORTS') || verify('WAP_SETTINGS')
    },
    {
      title: PAGE_TITLE.VOICE,
      icon: PhoneInTalk,
      href: PORTAL_PATH.VOICE,
      portalPrivilegeVerification: (verify: CheckIfUserHasPortalPrivilege) =>
        verify('VOICE_BILLING_REPORTS') || verify('VOICE_SETTINGS')
    },
    {
      title: PAGE_TITLE.USSD_EDITOR,
      icon: AppSettingsAltOutlined,
      href: EXTERNAL_PATH.USSD_EDITOR,
      portalPrivilegeVerification: (verify: CheckIfUserHasPortalPrivilege) => verify('USSD_SETTINGS'),
      excludeFromNavigation: true
    },
    {
      title: PAGE_TITLE.OPERATOR_LOOKUP,
      icon: CellTowerOutlined,
      href: PORTAL_PATH.OPERATOR_LOOKUP_BILLING,
      portalPrivilegeVerification: (verify: CheckIfUserHasPortalPrivilege) => verify('OPERATOR_LOOKUP_BILLING_REPORTS')
    }
  ]
};

const value: MenuSection = {
  title: SERVICE_CATEGORY_TITLE.VALUE,
  menuItems: [
    {
      title: PAGE_TITLE.AIRTIME_AND_DATA,
      icon: PhoneForwardedOutlined,
      href: PORTAL_PATH.AIRTIME_AND_DATA_BILLING,
      portalPrivilegeVerification: (verify: CheckIfUserHasPortalPrivilege) => verify('AIRTIME_AND_DATA_BILLING_REPORTS')
    },
    {
      title: PAGE_TITLE.ACCOUNT_TRANSFERS,
      icon: CreditScoreOutlined,
      href: PORTAL_PATH.ACCOUNT_TRANSFERS_BILLING,
      portalPrivilegeVerification: (verify: CheckIfUserHasPortalPrivilege) => verify('TRANSFER_BILLING_REPORTS')
    },
    {
      title: PAGE_TITLE.ONDEMAND,
      icon: ShopOutlined,
      href: PORTAL_PATH.ONDEMAND_BILLING,
      portalPrivilegeVerification: (verify: CheckIfUserHasPortalPrivilege) =>
        verify('ON_DEMAND_PAYMENT_AND_ACQUISITION_BILLING_REPORTS')
    },
    {
      title: PAGE_TITLE.PAYOUT,
      icon: AccountBalanceOutlined,
      href: PORTAL_PATH.PAYOUT_BILLING,
      portalPrivilegeVerification: (verify: CheckIfUserHasPortalPrivilege) => verify('PAYOUT_BILLING_REPORTS')
    },
    {
      title: PAGE_TITLE.MERCHANT_PAYMENT,
      icon: PaymentsOutlined,
      href: PORTAL_PATH.MERCHANT_PAYMENT_BILLING,
      portalPrivilegeVerification: (verify: CheckIfUserHasPortalPrivilege) => verify('MERCHANT_PAYMENT_BILLING_REPORTS')
    }
  ]
};

const identity: MenuSection = {
  title: SERVICE_CATEGORY_TITLE.IDENTITY,
  menuItems: [
    {
      title: PAGE_TITLE.CUSTOMER_VALIDATION,
      icon: InsertChartOutlined,
      href: PORTAL_PATH.CUSTOMER_VALIDATION_BILLING,
      portalPrivilegeVerification: (verify: CheckIfUserHasPortalPrivilege) =>
        verify('CUSTOMER_VALIDATION_BILLING_REPORTS')
    },
    {
      title: PAGE_TITLE.CUSTOMER_AUTHENTICATION,
      icon: BadgeOutlined,
      href: PORTAL_PATH.CUSTOMER_AUTHENTICATION_BILLING,
      portalPrivilegeVerification: (verify: CheckIfUserHasPortalPrivilege) =>
        verify('CUSTOMER_AUTHENTICATION_BILLING_REPORTS')
    },
    {
      title: PAGE_TITLE.CUSTOMER_ENROLLMENT,
      icon: AssignmentTurnedInOutlined,
      href: PORTAL_PATH.CUSTOMER_ENROLLMENT_BILLING,
      portalPrivilegeVerification: (verify: CheckIfUserHasPortalPrivilege) =>
        verify('CUSTOMER_ENROLLMENT_BILLING_REPORTS')
    }
  ]
};

export const menuConfig: MenuSection[] = [withoutSection, access, value, identity];
